<template lang="html">
	<section class="ctn-operation-form take-place">
		<div class="white-box row title">
			<router-link :to="{name: 'InvestmentsManual', params: isCgpi ? {clientId: client.id} : {kind: 'client'}}" class="ctn-icon">
				<span class="icon-arrow-back"></span>
			</router-link>
			<div class="label" v-if="this.$route.params.id">
				Modifier le produit
			</div>
			<div class="label" v-else>
				Ajouter un produit
			</div>
		</div>
		<div class="white-box">
			<edit-main :client-id="client ? client.id : null" :investmentProduct="investmentProduct" :kind="kind"></edit-main>
		</div>
	</section>
</template>

<script>
/* eslint-disable */
	import EditMain from './EditForm/Main'
	import _ from 'lodash'

	export default {
		name: 'InvestmentsManualForm',
		components: {
			EditMain
		},
		props: {
			kind: {type: String, default: 'cgpi'}
		},
		data () {
			return {
				client:  null,
				investmentProduct: {}
			}
		},
		created() {
			if (this.isCgpi) {
				this.client = this.$store.getters.getClient(this.$route.params.clientId);
			}
		},
		mounted () {
			this.initializeInvestmentProduct()
		},

		methods: {
			initializeInvestmentProduct () {
				if (!this.$route.params.id) {
					return
				}

				this.$store.dispatch('getInvestmentProduct', this.$route.params.id).then((result) => {
					this.investmentProduct = _.cloneDeep(result)
					this.investmentProduct.subscription_date = this.$moment(this.investmentProduct.subscription_date, 'DD/MM/YYYY h:mm').format('YYYY-MM-DD')
				}).catch(() => {
					this.$router.push({ name: '404' })
				})
			}
		},
		computed: {
			isCgpi () {
				return this.kind === 'cgpi'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// InvestmentsManualForm.vue?7fef9249